module.exports = __webpack_public_path__ + "static/media/count50Off_118.51816833.png";